import React from 'react';

const AshbyJobsLoading = () => {
  return (
    <div className="roles-list-loading">
      <div className="loader" />
    </div>
  );
};

export default AshbyJobsLoading;
